import $ from 'jquery';

/*
 * Create a dropdown menu whose items open when clicked 
 *
 * Adds the attribute 'open' to the parent menu item when a submenu is open.
 * 
 * Assumes the default Wordpress menu classes are used.
 */

class ClickDropdownMenu {
    constructor(selector) {
        this.menu = $(selector)
        this.parents = this.menu.find('.menu-item-has-children');
        this.buttons = this.menu.find('.menu-item-has-children > a');
        this.submenus = this.menu.find('.sub-menu');
        this.currentSubMenu = null;
        this.currentSubMenuIndex = 0;

        this.buttons.on('click', this.clickItem.bind(this));
        this.buttons.on('keydown', this.keyPress.bind(this));
        this.submenus.on('keydown', this.subMenuKeyPress.bind(this));
        $(document).on('click', this.clickDoc.bind(this));
        document.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

        this.buttons.attr('role', 'button');
        this.buttons.attr('aria-expanded', false);
        $('.current-menu-item').attr('aria-current', 'page');
    }

    clickItem(e) {
        e.preventDefault();

        var button = $(e.target).closest('.menu-item-has-children > a');
        var isOpen = button.attr('open');
        this.closeAll();

        if (!isOpen) {
            this.open(button);
        }
    }

    clickDoc(e) {
        if (!$(e.target).parents().hasClass('menu-item-has-children')) {
            this.closeAll();
        }
    }

    keyPress(e) {
        // if (e.which == 9) { // tab
        //     return;
        // }

        let handled = true;

        if (this.currentSubMenu) {
            this.subMenuKeyPress(e);
            return;
        }

        let index = this.buttons.index(e.target);

        switch (e.which) {
            case 32: // space
            case 13: // enter
                this.clickItem(e);
                break;
            case 37: // left
                index = Math.max(index - 1, 0);
                this.buttons.eq(index).trigger('focus');
                break;
            case 39: // right
                index = Math.min(index + 1, this.buttons.length - 1);
                this.buttons.eq(index).trigger('focus');
                break;
            default:
                handled = false;
                break;
        }

        if (handled)
            e.preventDefault();

    }

    subMenuKeyPress(e) {
        if (!this.currentSubMenu)
            return;

        switch (e.which) {
            case 38: // up
            case 37: // left
                this.currentSubMenuIndex = Math.max(0, this.currentSubMenuIndex - 1);
                this.currentSubMenu.eq(this.currentSubMenuIndex).find('a').first().trigger('focus');
                break;
            case 40: // down
            case 39: // right
                this.currentSubMenuIndex = Math.min(this.currentSubMenu.length - 1, this.currentSubMenuIndex + 1);
                this.currentSubMenu.eq(this.currentSubMenuIndex).find('a').first().trigger('focus');
                break;
            case 13: // enter
                this.currentSubMenu.eq(this.currentSubMenuIndex).find('a')[0].click();
                break;
            case 9: // tab
            case 27: // esc
                this.currentSubMenu.first().closest('.menu-item-has-children').find('a').first().trigger('focus');
                this.closeAll();
                break;
        }

        e.preventDefault();
    }

    onScroll() {
        this.closeAll();
    }

    closeAll() {
        this.close(this.buttons);
    }

    open(item) {
        item.attr('open', true);
        item.attr('aria-expanded', true);
        this.currentSubMenu = item.next('.sub-menu').children();
        this.currentSubMenuIndex = -1;
    }

    close(item) {
        item.removeAttr('open');
        item.attr('aria-expanded', false);
        this.currentSubMenu = null;
    }

    isSubmenuOpen() {
        return this.currentSubMenu != null;
    }
}

export default ClickDropdownMenu;
